import PopUp, { IPopUpRef } from "@/modules/ui-elements/PopUp"
import React, { use, useEffect, useImperativeHandle, useRef, useState } from "react";
import styles from './styles.module.css';
import Image from 'next/image';
import ColorPicker from "@/components/ColorPicker";
import { css } from "@emotion/react";
import useOtherCategory from "@/hooks/useOtherCategory";
import { createEmptyEditorJob, createPage, savePage, updateJobBatchEditor } from "@/modules/editor-v2/services/Jobs";
import { defaultDMSCanvasFile } from "../../../../utils/toolsConstants";
import { DMSCanvasFile, SerializedImageLayerInfo } from "local_modules/editor/src/Interfaces";
import { useRouter } from "next/router";
import LoaderSvg from '../UploadPopUp/loaderSmall.svg';
import { ToolType } from "../../../../utils/toolsConstants";
import { ICONS, Icon } from "@/modules/ui-elements/Icon";
export interface IBackgroundColorPopUpOptions {
    jobId,
    batchId
}  

export interface IBackgroundColorPopUpRef {
    open: (options:IBackgroundColorPopUpOptions)=>void,
    close: ()=>void
}

export interface IBackgroundColorPopUpProps {
    onBackPress: ()=>void,
    toolType: number
}

const BackgroundColorPopUp = React.forwardRef<IBackgroundColorPopUpRef,IBackgroundColorPopUpProps>(function BackgroundColorPopUp(props,ref) {

    const popUpRef = useRef<IPopUpRef>(null);
    const [isLoading, setIsLoading] = React.useState(false);
    const [jobId, setJobId] = useState<String>("");
    const [batchId, setBatchId] = useState<String>("");
    const colorPickerRef = useRef<any>();
    const [selectedColor, setSelectedColor] = useState("#FFFFFF")
    const {otherCategory, otherSubCategory} = useOtherCategory();
    const router = useRouter();

    useImperativeHandle(ref,()=>({
        open: ({batchId, jobId})=>{
            jobId ? setJobId(jobId) : setBatchId(batchId)
            popUpRef.current.open();
        },
        close: ()=>{
            popUpRef.current.close();
        }
    }))

    const onColorSelectGenerator = (color) => () => {
        setSelectedColor(color);
    }

    useEffect(()=>{
        colorPickerRef.current?.setColor(selectedColor)
    },[selectedColor]);

    const onNextPress = async () => {
        setIsLoading(true);
        const presetDetails = {
            size: {
                height: 1500,
                width: 1500
            },
            coverage: 80,
            position: "center",
            backgroundColor: selectedColor,
        }
        jobId ? router.push(`/dashboard/batch-editor/${jobId}?presetDetails=${encodeURIComponent(JSON.stringify(presetDetails))}`) 
        : router.push(
          `/dashboard/batch-editor?batchMode=multiple&batchJobId=${batchId}?presetDetails=${encodeURIComponent(JSON.stringify(presetDetails))}`
        );
        popUpRef.current.close();
        return;
    }

    const style = {display:"flex", flex:1};

    return <PopUp ref={popUpRef} width={600}  disableBackdropClick={isLoading} showCloseButton={true} >
         <div className={styles.header}>
            <div className={styles.headerIcon} onClick={props.onBackPress}>
                <Icon src={ICONS.chevronLeftDark} height={16} width={16} />
            </div>
            <div className={styles.Heading}>{props?.webListingScreen?.YourProjectsTitle || "Select Color"}</div>
        </div>
        <div className={styles.row}>
            <div css={css`
                padding: 24px;
                border: 1px solid #EEEEEE;
                border-radius: 4px;
            `} style={style}>
                <div style={{width:'100%', display:'flex', flexDirection:'column', justifyContent:'space-between'}}>
                    
                    {/* @ts-ignore */}
                    <ColorPicker ref={colorPickerRef} defaultValue="#FFFFFF" onChange={(color)=>onColorSelectGenerator(color)()}/>
                    
                </div>
            </div>
        </div>
        <div style={{flexDirection:'row', display:'flex', gap:10}}>
            <div onClick={onNextPress} style={{flex:1, background:isLoading?"#EEEEEE":"#262626", cursor:'pointer', textAlign:'center', padding:12, fontFamily:'Objectivity-Medium, sans-serif', fontSize:16, lineHeight:"25.6px", borderRadius:8, color:'white', transition:"all 0.5s linear"}}>
                {isLoading?<LoaderSvg />:"Next"}
            </div>
        </div>
    </PopUp>

})

export default BackgroundColorPopUp;